
import React from 'react';
import { TableHead, TableRow, TableHeader } from '@/components/ui/table';
import { ArrowUp, ArrowDown } from 'lucide-react';
import { Transaction } from '@/types/payment';

interface TransactionTableHeadProps {
  sortField: keyof Transaction;
  sortDirection: 'asc' | 'desc';
  toggleSort: (field: keyof Transaction) => void;
}

const TransactionTableHead: React.FC<TransactionTableHeadProps> = ({ 
  sortField, 
  sortDirection, 
  toggleSort 
}) => {
  const renderSortIcon = (field: keyof Transaction) => {
    if (field !== sortField) return null;
    
    return sortDirection === 'asc' 
      ? <ArrowUp className="inline ml-1 h-4 w-4" /> 
      : <ArrowDown className="inline ml-1 h-4 w-4" />;
  };

  return (
    <TableHeader>
      <TableRow>
        <TableHead 
          className="cursor-pointer" 
          onClick={() => toggleSort('id')}
        >
          ID {renderSortIcon('id')}
        </TableHead>
        <TableHead 
          className="cursor-pointer" 
          onClick={() => toggleSort('sender')}
        >
          Sender {renderSortIcon('sender')}
        </TableHead>
        <TableHead 
          className="cursor-pointer" 
          onClick={() => toggleSort('senderEmail')}
        >
          Sender Email {renderSortIcon('senderEmail')}
        </TableHead>
        <TableHead 
          className="cursor-pointer" 
          onClick={() => toggleSort('recipient')}
        >
          Recipient {renderSortIcon('recipient')}
        </TableHead>
        <TableHead 
          className="cursor-pointer" 
          onClick={() => toggleSort('recipientEmail')}
        >
          Recipient Email {renderSortIcon('recipientEmail')}
        </TableHead>
        <TableHead 
          className="cursor-pointer text-right" 
          onClick={() => toggleSort('amount')}
        >
          Amount {renderSortIcon('amount')}
        </TableHead>
        <TableHead 
          className="cursor-pointer text-right" 
          onClick={() => toggleSort('fee')}
        >
          Fee {renderSortIcon('fee')}
        </TableHead>
        <TableHead 
          className="cursor-pointer" 
          onClick={() => toggleSort('timestamp')}
        >
          Date & Time {renderSortIcon('timestamp')}
        </TableHead>
        <TableHead 
          className="cursor-pointer" 
          onClick={() => toggleSort('status')}
        >
          Status {renderSortIcon('status')}
        </TableHead>
        <TableHead 
          className="cursor-pointer" 
          onClick={() => toggleSort('method')}
        >
          Method {renderSortIcon('method')}
        </TableHead>
      </TableRow>
    </TableHeader>
  );
};

export default TransactionTableHead;
